import { storeConstants } from '@utils/constants';
import {
    normalizeReportsCustomerActivities,
    normalizeReportsCustomerActivitiesTotals,
} from '@utils/storeDataNormalization';
import storeModuleFactory from '@helpers/storeModuleFactory';
import { mutationTypes } from '@helpers/storeFactories/helpers';
import { apiService } from '@api';

const STORE_NAME = 'customersActivities';

const store = storeModuleFactory.createModuleView(
    STORE_NAME,
    {
        get: apiService.reports.customersActivities.get,
    },
    {
        actionGetOptionsDefault: {
            refresh: false,
            offset: 0,
            limit: storeConstants.ITEMS_PER_PAGE,
        },
        mapListItemFn: normalizeReportsCustomerActivities,
    },
    {
        state: {
            filters: {},
        },
        getters: {
            filters: (state) => state.filters,
            total: (state) => state.totalCount,
            reportTotals: (state) => normalizeReportsCustomerActivitiesTotals(state.totals),
        },
        mutations: {
            [mutationTypes.UPDATE_FILTERS](state, { filters }) {
                state.filters = filters;
            },
        },
        actions: {
            async updateFilters({ commit }, { filters }) {
                return commit(mutationTypes.UPDATE_FILTERS, { filters });
            },
        },
    }
);

export default store;
